import { httpsCallable } from 'firebase/functions';
import { RegistrationFormInterface, ResponseRegistrationInterface, FormDataErrorInterface } from '../../domain/interfaces/RegistrationInterface';
import { useAppDispatch, useAppSelector } from '../../../../../hooks';
import { functions } from '../../../../../config/firebase';
import {
    setFormDataReducer,
    submitRegistrationStartReducer,
    submitRegistrationSuccessReducer,
    submitRegistrationFailureReducer,
    fetchDepartmentsThunk,
    fetchCitiesByDepartmentThunk,
    clearRegistrationErrorReducer,
    setFormDataErrorReducer,
    resetRegistrationStateReducer
} from '../slice/RegistrationSlice';

const useRegistrationInfrastructure = () => {
    const dispatch = useAppDispatch();
    const registrationState = useAppSelector(state => state.registration);

    const registerUserCallable = httpsCallable<RegistrationFormInterface, ResponseRegistrationInterface>(functions, 'registerUser');

    const setRegisterFormInfrastructure = (formData: Partial<RegistrationFormInterface>) => {
        dispatch(setFormDataReducer(formData));
    }

    const setFormDataErrorInfrastructure = (formDataError: Partial<FormDataErrorInterface>) => {
        dispatch(setFormDataErrorReducer(formDataError));
    }

    const fetchDepartmentsInfrastructures = () => {
        dispatch(fetchDepartmentsThunk());
    }

    const fetchCitiesByDepartmentInfrastructure = (departmentId: number) => {
        dispatch(fetchCitiesByDepartmentThunk(departmentId));
    }

    const clearRegistrationErrorInfrastructure = () => {
        dispatch(clearRegistrationErrorReducer());
    }

    const submitRegistrationInfrastructure = async () => {
        dispatch(submitRegistrationStartReducer());
        try {
            // The Firebase SDK wraps this in a { data: ... } object automatically.
            // We need to inject the candidateName from the environment.
            const candidateName = process.env.REACT_APP_CANDIDATE_NAME || "Alejandro Ospina";
            const payloadWithCandidate = {
                ...registrationState.formData,
                candidateName
            };
            const result = await registerUserCallable(payloadWithCandidate);
            dispatch(submitRegistrationSuccessReducer(result.data));
            return result.data;
        } catch (error: any) {
            const errorMessage = error.message || "Ocurrió un error inesperado.";
            dispatch(submitRegistrationFailureReducer(errorMessage));
        }
    };

    const resetRegistrationStateInfrastructure = () => {
        dispatch(resetRegistrationStateReducer());
    }

    return {
        setRegisterFormInfrastructure,
        submitRegistrationInfrastructure,
        fetchDepartmentsInfrastructures,
        fetchCitiesByDepartmentInfrastructure,
        clearRegistrationErrorInfrastructure,
        setFormDataErrorInfrastructure,
        resetRegistrationStateInfrastructure,
        registrationState
    }
}

export default useRegistrationInfrastructure;
